<template>
	<div class="sbw-list-container init">
		<div class="cps-page-top">
			<div class="jc-page-header">
				<el-page-header :title="$t('sbw.text.sbw')" />
				<div class="jc-box-action">
					<a v-bind:href="Config.SBW_HELP_URL" target="_blank">{{ $t('sbw.help.doc') }}</a>
				</div>
			</div>
			<div class="jc-page-content">
				<div class="jc-container-table">
					<div class="jc-container-table-actionBar flex-display">
						<!--刷新、地域、申请-->
						<el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon"
									@click="updateList('refresh')">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-radio-group v-model="region" @change="regionChange">
									<el-radio-button v-for="(area, index) in regions" :key="index" :label="area.region">
										{{ area.regionName }}
									</el-radio-button>
								</el-radio-group>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="jumpToCreate()">{{ $t('eip.text.apply') }}
								</el-button>
							</el-form-item>
						</el-form>
						<!--搜索、自定义、下载-->
						<el-form class="jc-box-table-search" :inline="true" @submit.native.prevent>
							<el-form-item>
								<el-input v-entire-placeholder @keyup.enter.native="updateList('refresh')"
									:placeholder="currentPlaceholder" v-model="currentSearchValue" style="width:412px">
									<el-select slot="prepend" id="my-select" v-model="currentSearch" @change="changeSearch"
										:placeholder="$t('listPage.placeholder.choose')" style="width:115px">
										<el-option class="my-select-input" v-for="item in searchSelect"
											:key="item.searchValue" :label="item.searchLabel" :value="item.searchValue">
										</el-option>
									</el-select>
									<el-button slot="append" icon="jc-icon-search" class="search-icon"
										@click="updateList('refresh')"></el-button>
								</el-input>
							</el-form-item>
							<el-form-item>
								<jcb-tag-filter :service-code="ServiceCodeConstant.CPSBW"
									:visible.sync="batchEditTagDialogVisible" :region-id="region ? region : ''"
									@checkedTags="filterWithCheckedTags">
								</jcb-tag-filter>
							</el-form-item>
							<el-form-item>
								<el-button icon="el-icon-setting" class="jc-button-icon cps-custom-icon"
									@click="customVisible = true" :title="$t('listPage.text.customList')"></el-button>
							</el-form-item>
							<el-form-item>
								<el-button class="jc-button-icon cps-custom-icon" icon="jc-icon-download"
									@click="exportList" :title="$t('listPage.text.exportList')"></el-button>
							</el-form-item>
						</el-form>
					</div>
					<!--共享带宽列表-->
					<el-table :data="tableData" style="width:100%" class="jc-list-table jc-table-header-cell"
						v-loading="refreshLoading" ref="listTable" :empty-text="$t('speechCraft.listEmptyText')">
						<!--ID/名称-->
						<el-table-column :label="$t('sbw.text.idOrName')" min-width="150" key="bandwidthPackageId"
							v-if="customInfo !== null && customInfo['id'].selected">
							<template slot-scope="scope">
								<!--ID-->
								<el-tooltip class="item" effect="dark" :content="scope.row.bandwidthPackageId"
									placement="top">
									<span>{{ scope.row.bandwidthPackageId | maybeEmpty }}</span>
								</el-tooltip>
								<br />
								<!--实例名称-->
								<el-tooltip class="item" effect="dark" :content="scope.row.name" placement="top">
									<a href="javascript:void(0)"
										@click="jumpToDetail(scope.row.bandwidthPackageId, scope.row.region)">
										{{ scope.row.name | maybeEmpty }}
									</a>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--可用区-->
						<el-table-column prop="az" min-width="60" key="az" :label="$t('list.region')"
							v-if="customInfo !== null && customInfo['az'].selected">
							<template slot-scope="scope">
								<span>{{ $t('eip.text.allAz') }}</span>
							</template>
						</el-table-column>
						<!--线路-->
						<el-table-column prop="lineType" min-width="60" :label="$t('eip.text.line')"
							v-if="customInfo !== null && customInfo['line'].selected">
							<template slot-scope="scope">
								<span>{{ scope.row.lineTypeName | maybeEmpty }}</span>
							</template>
						</el-table-column>
						<!--已加入IP-->
						<el-table-column prop="ipCount" min-width="60" :label="$t('sbw.text.alreadyJoinIp')"
							v-if="customInfo !== null && customInfo['ipCount'].selected">
							<template slot-scope="scope">
								<a href="javascript:void(0)"
									@click="jumpToIpDetail(scope.row.bandwidthPackageId, scope.row.region)">{{
										scope.row.ipCount }}</a>
							</template>
						</el-table-column>
						<!--带宽上限-->
						<el-table-column min-width="95" key="bandwidth" prop="bandwidth"
							:label="$t('eip.text.bandwidthLimit')" v-if="customInfo !== null && customInfo['bw'].selected">
							<template slot-scope="scope">
								<span class="english-wrap">
									{{ scope.row.bandwidth >= 0 ? scope.row.bandwidth + 'Mbps' : '--' }}
								</span>
								<p>
									{{ scope.row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION ?
										$t('sbw.text.postUsage') : $t('eip.text.independentBandwidth') }}
								</p>
							</template>
						</el-table-column>
						<!--计费信息-->
						<el-table-column key="charge" min-width="200" :label="$t('listPage.tableLabel.billingInformation')"
							v-if="customInfo !== null && customInfo['fee'].selected">
							<template slot-scope="scope">
								<div v-if="scope.row.chargeStatus">
									<!--如果计费方式为包年包月-->
									<div v-if="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
										<p>
											{{ scope.row.chargeModeName }}
											<span v-if="getCheckExpireInfo(scope.row) === 'will-retire'" style="color:red;">
												{{ '(' + $t('listPage.text.hasExpired') + ')' }}
											</span>
										</p>
                                        <p class="list-expire-p">
                                            {{ scope.row.charge.chargeStartTime + ' ' + $t('listPage.text.created') }}
                                        </p>
										<p style="color:red;"
											v-if="getCheckExpireInfo(scope.row) === 'will-retire' && scope.row.retireTime"
											class="list-expire-p">
											{{ scope.row.retireTime + ' ' + $t('listPage.text.freed') }}
										</p>
										<p style="color:red;" v-if="getCheckExpireInfo(scope.row) === 'will-expire'"
											class="list-expire-p">
											{{ scope.row.expire + ' ' + $t('listPage.text.expired') }}</p>
										<p v-if="getCheckExpireInfo(scope.row) === 'available'" class="list-expire-p">
											{{ scope.row.expire + ' ' + $t('listPage.text.expired') }}
										</p>
									</div>
									<!--如果计费方式为后付费-->
									<div v-if="scope.row.chargeMode === ChargeModeConstant.POSTPAID_BY_DURATION">
										<p>
											{{ scope.row.chargeModeName }}
											<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
												style="color:red;">
												{{ '(' + $t('eip.text.arrear') + ')' }}
											</span>
										</p>
										<p v-if="scope.row.chargeStatus === 'normal'" class="list-expire-p">
											{{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetwork.create') }}
										</p>
										<p style="color:red;"
											v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.retireTime"
											class="list-expire-p">
											{{ scope.row.retireTime + ' ' + $t('listPage.text.freed') }}
										</p>
									</div>
									<!--如果计费方式为按用量-->
									<div v-if="scope.row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION">
										<p>
											{{ scope.row.chargeModeName }}
											<span v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus)"
												style="color:red;">
												{{ '(' + $t('eip.text.arrear') + ')' }}
											</span>
										</p>
										<p v-if="scope.row.chargeStatus === 'normal'" class="list-expire-p">
											{{ scope.row.charge.chargeStartTime + ' ' + $t('privateNetwork.create') }}
										</p>
										<p style="color:red;"
											v-if="ArrearConstantArray.includes(scope.row.charge.chargeStatus) && scope.row.retireTime"
											class="list-expire-p">
											{{ scope.row.retireTime + ' ' + $t('listPage.text.freed') }}
										</p>
									</div>
								</div>
								<div v-else>
									<span>--</span>
								</div>
							</template>
						</el-table-column>
						<!--标签-->
						<el-table-column :label="$t('listPage.text.tags')" key="tag"
							v-if="customInfo !== null && customInfo['tags'].selected" min-width="110">
							<template slot-scope="scope">
								<el-tooltip class="item" effect="dark" :content="scope.row.tagPairs" placement="top">
									<span>{{ scope.row.tagPairs | maybeEmpty }}</span>
								</el-tooltip>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column key="operation" :label="$t('listPage.tableLabel.operation')"
							v-if="customInfo !== null && customInfo['operation'].selected">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="openAddIpDialog(scope.row)"
									class="cps-select-form-item"
									:class="{ 'cps-dropdown-disabled': disableByChargeStatus(scope.row) || scope.row.ipCount >= SbwAddIpMaxCount || !scope.row.chargeStatus }">
									{{ $t('sbw.text.addIp') }}
									<!--超过300不支持添加IP-->
									<div class="cps-form-tip add-ip-tip" v-if="scope.row.ipCount >= SbwAddIpMaxCount">
										{{ $t('sbw.help.addIpTip') }}
									</div>
									<!--实例停服不支持添加IP-->
									<div class="cps-form-tip add-ip-tip" v-if="disableByChargeStatus(scope.row)">
										{{ $t('privateNetInstance.operations.overdueTip') }}
									</div>
									<!--无计费信息不支持添加IP-->
									<div class="cps-form-tip add-ip-tip" v-if="!scope.row.chargeStatus">
										{{ $t('eip.help.noChargeInfo') }}
									</div>
								</a>
								<!--更多-->
								<el-dropdown size="200px">
									<span class="jc-dropdown-link">
										{{ $t('operations.more') }}<i class="jc-icon-caret-bottom jc-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown" class="operation-list-dropdown-menu">
										<!--打开修改带宽弹框-->
										<a href="javascript:void(0)" @click="openModifyBandwidthDialog(scope.row)"
											class="cps-select-form-item">
											<el-dropdown-item
												:disabled="disableByChargeStatus(scope.row) || !scope.row.chargeStatus">
												{{ $t('eip.text.modifyBandwidth') }}
											</el-dropdown-item>
											<!--实例停服不支持修改带宽-->
											<div class="cps-form-tip add-ip-tip" v-if="disableByChargeStatus(scope.row)">
												{{ $t('privateNetInstance.operations.overdueTip') }}
											</div>
											<!--无计费信息不支持修改带宽-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--跳转到续费页面（按配置资源不支持续费）-->
										<a href="javascript:void(0)" class="cps-select-form-item"
											@click="selectOpts(SbwOperationConstant.RENEW, scope.row, 'renew', !scope.row.chargeStatus || scope.row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION)">
											<el-dropdown-item
												:disabled="!scope.row.chargeStatus || scope.row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION">
												{{ $t('operations.renew.name') }}
											</el-dropdown-item>
											<!--按用量计费不支持续费-->
											<div class="cps-form-tip"
												v-if="scope.row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION">
												{{ $t('sbw.help.payByEnhancedNotAllowedRenew') }}
											</div>
											<!--无计费信息不支持续费-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--编辑标签-->
										<a class="cps-select-form-item" href="javascript:void(0)"
											@click="showEditTag(scope.row)">
											<el-dropdown-item :disabled="!scope.row.chargeStatus">
												{{ $t('sbw.operations.edittag.name') }}
											</el-dropdown-item>
											<!--无计费信息不支持编辑标签-->
											<div class="cps-form-tip" v-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
										<!--删除（包年包月资源不支持删除）-->
										<a href="javascript:void(0)" class="cps-select-form-item"
											@click="openDeleteBandwidthDialog(scope.row)">
											<el-dropdown-item
												:disabled="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || scope.row.status === 'associate' || !scope.row.chargeStatus || (scope.row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION && !isExceedMonth(scope.row)) || scope.row.ipCount > 0">
												{{ $t('privateNetwork.delete') }}
											</el-dropdown-item>
											<!--包年包月不支持删除-->
											<div class="cps-form-tip"
												v-if="scope.row.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
												{{ $t('eip.help.paidByDurationDeleteNotAllowed') }}
											</div>
											<!--按用量计费未使用一个完整自然月不支持删除-->
											<div class="cps-form-tip"
												v-else-if="scope.row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION && !isExceedMonth(scope.row)">
												{{ $t('sbw.help.unExceedMonth') }}
											</div>
											<!--已加入IP不支持删除-->
											<div class="cps-form-tip" v-else-if="scope.row.ipCount > 0">
												{{ $t('sbw.help.deleteSbwTip') }}
											</div>
											<!--无计费信息不支持删除-->
											<div class="cps-form-tip" v-else-if="!scope.row.chargeStatus">
												{{ $t('eip.help.noChargeInfo') }}
											</div>
										</a>
									</el-dropdown-menu>
								</el-dropdown>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<custom :visible.sync="customVisible" v-if="customVisible" :optionArr="optionArr" :type="type">
			</custom>
			<!--添加Ip-->
			<add-ip v-if="addIpDialogVisible" :dialog-visible.sync="addIpDialogVisible" :detail-data="currentRow"
				:region="region" @refresh="updateList('refresh')">
			</add-ip>
			<!--调整带宽-->
			<modify-bandwidth :dialog-visible="modifyDialogVisible" @ifDialogVisible="syncModifyDialog"
				:detail-data="currentRow" pageType="SBW">
			</modify-bandwidth>
			<!--编辑标签-->
			<jcb-tag-edit :visible.sync="editTagDialogVisible" :service-code="ServiceCodeConstant.CPSBW"
				:region-id="currentRow.region ? currentRow.region : ''"
				:resource-ids="currentRow.bandwidthPackageId ? [currentRow.bandwidthPackageId] : []"
				@complete="updateList('refresh')">
			</jcb-tag-edit>
			<!--删除-->
			<delete-sbw :dialog-visible="deleteDialogVisible" @ifDialogVisible="syncDeleteDialog" :detail-data="currentRow"
				@refresh="updateList('refresh')">
			</delete-sbw>
		</div>
		<div ref="footer" class="cps-page-footer block jc-container-table-actionBar" v-if="total > 0">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
				:page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
import {
	SbwOperationConstant,
	ChargeModeConstant,
	OverdueConstantArray,
	ArrearConstantArray,
	ServiceCodeConstant,
	ChargeModeMap,
	SbwAddIpMaxCount
} from '@/common/Constants';
import { getListBandwidthPackages } from '@/api/sbw/list/actions';
import { operations } from '@/common/SbwPopHelper';
import { getYMD } from '@/common/dataHelper';
import custom from '@/components/common/custom/Custom';
import AddIp from '@/components/sbw/addIp/AddIp';
import ModifyBandwidth from '@/components/common/modifyBandwidth/ModifyBandwidth';
import DeleteSbw from '@/components/sbw/deleteSbw/DeleteSbw';
const initPage = 1;
export default {
	components: {
		custom,
		AddIp,
		ModifyBandwidth,
		DeleteSbw,
	},
	name: 'SbwList',
	data() {
		// 模糊搜索条件设置
		const searchSelect = [
			{
				searchValue: 'sharedBandwidthName',
				searchLabel: this.$t('sbw.text.sharedBandwidthName')
			},
			{
				searchValue: 'sharedBandwidthId',
				searchLabel: this.$t('sbw.text.sharedBandwidthId')
			}
		];
		this.ServiceCodeConstant = ServiceCodeConstant;
		this.SbwOperationConstant = SbwOperationConstant;
		this.ChargeModeConstant = ChargeModeConstant;
		this.ChargeModeMap = ChargeModeMap;
		this.OverdueConstantArray = OverdueConstantArray;
		this.ArrearConstantArray = ArrearConstantArray;
		this.SbwAddIpMaxCount = SbwAddIpMaxCount;
		return {
			refreshLoading: true,
			currentPage: initPage,
			form: {},
			regions: [
			],
			region: '',
			tableData: [],
			// 批量编辑标签组件是否显示
			batchEditTagDialogVisible: true,
			// 标签过滤后的资源ID
			filteredResourceIds: [],
			currentSearch: 'sharedBandwidthName',
			// 当前搜索input框值
			currentSearchValue: '',
			// 搜索条件下拉选
			searchSelect,
			// 当前搜索条件对应placeholder
			currentPlaceholder: this.$t('sbw.placeholder.search.sharedBandwidthName'),
			pageSize: 20,
			pageSizes: [20, 50, 100], // 可选每页展示多少条
			total: 0,
			// 自定义列表是否显示
			customVisible: false,
			// 自定义列表表头
			optionArr: [
				{
					// ID/地址
					label: this.$t('sbw.text.idOrName'),
					value: 'id'
				},
				{
					// 线路
					label: this.$t('eip.text.line'),
					value: 'line'
				},
				{
					// 已加入IP
					label: this.$t('sbw.text.alreadyJoinIp'),
					value: 'ipCount'
				},
				{
					// 可用区
					label: this.$t('list.region'),
					value: 'az'
				},
				{
					// 带宽
					label: this.$t('eip.text.bandwidth'),
					value: 'bw'
				},
				{
					// 计费信息
					label: this.$t('list.chargeInfo'),
					value: 'fee'
				},
				{
					// 标签
					label: this.$t('listPage.text.tags'),
					value: 'tags'
				},
				{
					// 操作
					label: this.$t('listPage.tableLabel.operation'),
					value: 'operation'
				}
			],
			// 自定义列表类型
			type: 'cpsBandwidthPackageList',
			// 筛选条件
			statusFilter: [],
			//添加Ip弹框是否可见
			addIpDialogVisible: false,
			// 修改带宽弹框是否可见
			modifyDialogVisible: false,
			// 编辑标签组件是否显示
			editTagDialogVisible: false,
			// 删除共享带宽弹框是否可见
			deleteDialogVisible: false,
			// 当前行所有数据
			currentRow: {},
		};
	},
	computed: {
		customInfo() {
			return this.$store.state.customInfo[this.type];
		}
	},
	watch: {
		region(newValue) {
			if (newValue) {
				this.regionChange()
			}
		},
	},
	created() {
		if (this.customInfo === null) {
			this.getCustomInfo();
		}
		this.getRegions();
	},
	mounted() {
	},
	methods: {
		/**
		   * 判断当前时间与到期、释放时间关系
		   * @param row
		   * @return {string}
		   */
		getCheckExpireInfo(row) {
			if (row.charge.chargeExpiredTime) {
				const now = Date.now();
				const expire = (new Date(row.charge.chargeExpiredTime)).getTime();
				const DAYS = 1000 * 60 * 60 * 24;
				if (now > expire && row.charge.chargeRetireTime) {
					return 'will-retire';
				}
				if (expire - now > 7 * DAYS) {
					return 'available';
				}
				return 'will-expire';
			}
		},
		// 判断操作是否应该因不正确的计费状态而被禁用
		disableByChargeStatus(row) {
			if (OverdueConstantArray.includes(row.charge.chargeStatus)) {
				return true;
			}
			return false;
		},
		// 切换可用区
		regionChange() {
			this.currentSearchValue = '';
			this.pageSize = 20;
			this.currentPage = initPage;
			this.searchType = 'name';
			this.updateList();
		},
		// 获得可用区
		getRegions() {
			const params = {
				networkType: 'vpc'
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				this.regions = res.data.regions.map(item => {
					return {
						region: item.region,
						regionName: item.regionName
					}
				})
				this.region = this.$route.query.region || this.regions[0].region
			});
		},
		getRegionName(region) {
			let regionName = '';
			this.regions.forEach((item) => {
				if (region === item.region) {
					regionName = item.regionName;
				}
			});
			return regionName;
		},
		// 获取共享带宽列表数据
		getSwbListData() {
			this.refreshLoading = true;
			// 基础参数
			const param = {
				region: this.region,
				pageNumber: this.currentPage,
				pageSize: this.pageSize,
			};
			// 搜索部分添加参数
			if (this.currentSearchValue !== '') {
				switch (this.currentSearch) {
					case 'sharedBandwidthName': {
						param.name = this.currentSearchValue;
						break;
					}
					case 'sharedBandwidthId': {
						param.bandwidthPackageIds = this.currentSearchValue;
						break;
					}
					default:
						break;
				}
			}
			if (this.filteredResourceIds.length) {
				param.bandwidthPackageIds = this.filteredResourceIds.join(',');
			}
			getListBandwidthPackages(param)
				.then(res => {
					const list = res.data.bandwidthPackages;
					this.tableData = res.data.bandwidthPackages.map(item => {
						item.chargeMode = item.charge.chargeMode;
						item.chargeModeName = item.charge.chargeMode ? this.ChargeModeMap[item.charge.chargeMode.toUpperCase()] : '';
						item.expire = item.charge.chargeExpiredTime;
						item.retireTime = item.charge.chargeRetireTime;
						item.chargeStatus = item.charge.chargeStatus;
						item.tagPairs = '';
						if (item.tags && item.tags.length > 0) {
							for (const tag of item.tags) {
								item.tagPairs += `${tag.key}:${tag.value},`;
							}
							item.tagPairs = item.tagPairs.substring(0, item.tagPairs.length - 1);
						}
						return item
					})
					this.total = res.data.totalCount;
				})
				.catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.tableData = [];
						this.total = 0;
					} catch (ex) {
						console.log(ex);
					}
				}).finally(() => {
					this.refreshLoading = false;
				});
		},
		updateList(type) {
			if (type === 'refresh') {
				this.refreshLoading = true;
				this.currentPage = initPage;
			}
			this.getSwbListData();
		},

		filterWithCheckedTags(filterTags, tagKeys, resourceIds) {
			if (tagKeys.length !== 0) {
				this.filteredResourceIds = resourceIds;
			} else {
				this.filteredResourceIds = [];
			}
			this.updateList();
		},
		// 跳转到详情页
		jumpToDetail(id, region) {
			this.$router.push({
				path: `/sbw/detail/${id}/${region}`,
				query: {
					regionName: this.getRegionName(region),
					tabName: 'source'
				}
			});
		},
		// 跳转到创建页
		jumpToCreate() {
			this.$router.push({
				path: '/sbw/create',
				query: {
					region: this.region
				}
			});
		},
		jumpToIpDetail(id, region) {
			this.$router.push({
				path: `/sbw/detail/${id}/${region}/`,
				query: {
					id,
					region,
					regionName: this.getRegionName(region),
					tabName: 'sbwIp'
				}
			});
		},
		// 修改搜索条件
		changeSearch() {
			const searchPlaceholder = this.$t('sbw.placeholder.search');
			const currentSearchVar = this.currentSearch;
			this.currentPlaceholder = searchPlaceholder[currentSearchVar];
			// 清空当前搜索条件
			this.currentSearchValue = '';
		},
		// 导出列表接口
		exportList() {
			let temp = '';
			if (this.currentSearchValue !== '') {
				switch (this.currentSearch) {
					case 'sharedBandwidthName': {
						temp = `&name=${this.currentSearchValue}`;
						break;
					}
					case 'sharedBandwidthId': {
						temp = `&bandwidthPackageIds=${this.currentSearchValue}`;
						break;
					}
					default:
						break;
				}
			}
			const url = `/cps_api/api/export/listBandwidthPackages?pageNumber=${this.currentPage}&pageSize=${this.pageSize}&region=${this.region}${temp}`;
			window.open(url, '_self');
		},
		// 切换每一页多少条
		handleSizeChange(val) {
			this.pageSize = val;
			this.updateList('refresh');
		},
		// 切换当前页
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getSwbListData();
		},
		getCustomInfo() {
			const param = {
				pageKey: this.type
			};
			Ajax.get({
				url: '/api/usercenter',
				action: '/getCustomInfo',
				param,
				success: (data) => {
					if (data.customInfo) {
						this.$store.commit('GET_CUSTOMINFO', { value: data.customInfo, type: this.type });
					}
				}
			});
		},
		openAddIpDialog(row) {
			if (this.disableByChargeStatus(row) || row.ipCount >= this.SbwAddIpMaxCount || !row.chargeStatus) {
				return
			}
			this.currentRow = row;
			this.addIpDialogVisible = true;
		},
		openModifyBandwidthDialog(row) {
			if (this.disableByChargeStatus(row) || !row.chargeStatus) {
				return false;
			}
			this.currentRow = row;
			this.modifyDialogVisible = true;
		},
		openDeleteBandwidthDialog(row) {
			if (row.chargeMode === this.ChargeModeConstant.PREPAID_BY_DURATION
				|| row.status === 'associate' || !row.chargeStatus || (row.chargeMode === ChargeModeConstant.ENHANCED_BY_DURATION && !this.isExceedMonth(row)) || row.ipCount > 0) {
				return false;
			}
			this.currentRow = row;
			this.deleteDialogVisible = true;
		},
		// 同步修改带宽子组件传出来的dialog是否显示
		syncModifyDialog(data) {
			this.modifyDialogVisible = data;
		},
		syncDeleteDialog(data) {
			this.deleteDialogVisible = data;
		},
		// 编辑标签弹框
		showEditTag(row) {
			if (!row.chargeStatus) {
				return false;
			}
			this.currentRow = row;
			this.editTagDialogVisible = true
		},
		// 更多中的操作
		selectOpts(caseOps, cps, operate, disabled, otherDisabled) {
			if (disabled || otherDisabled) {
				return;
			}
			operations(caseOps, this, cps, 'list');
		},
		// 计算时间差值有没有超过1个自然月
		isExceedMonth(row) {
			let [createTime] = row.createTime.split(/\s+/);
			let [endTime] = getYMD(Date.now()).split(/\s+/);
			let startArr = createTime.split('-').map(Number);
			let endArr = endTime.split('-').map(Number);
			let [year, month] = endArr.map((n, i) => n - startArr[i]);
			if (year > 0) {
				return true
			}
			if (month > 0) {
				return true
			}
			return false
		}
	}
};
</script>


<style lang="scss">
@import '../../../assets/scss/listComon.scss';
@import '../../../assets/scss/paginationCommon.scss';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/sbw/list/List.vue